import React from 'react'
import { Mask } from 'antd-mobile'
import styled from 'styled-components'
import { Icon } from '../icon'

export interface PopImageProps {
  visible: boolean
  onClose: () => void
  url: string
}

const PositionalContainer = styled.div`
  position: absolute;
  width: 80%;
  top: 40%;
  left: 10%;
  transform: translateY(-50%);
`
const Image = styled.img`
  width: 100%;
  border-radius: 0.25rem;
`
const Close = styled.div.attrs(({ theme: { colors } }) => ({
  children: (
    <>
      <Icon code="guanbi" size="0.875rem" color={colors.white} />
      <span style={{ marginLeft: '0.25rem' }}>关闭</span>
    </>
  )
}))`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: ${props => props.theme.colors.white};
  font-size: 1rem;
  cursor: pointer;
`
export const PopImage: React.VFC<PopImageProps> = ({ visible, url, onClose }) => {
  return (
    <Mask
      visible={visible}
      onMaskClick={onClose}
      opacity="thick"
      forceRender={true} // TODO experimental, eager load images
    >
      <PositionalContainer>
        <Close />
        <Image src={url} width="80%" />
      </PositionalContainer>
    </Mask>
  )
}
